module.exports = __webpack_public_path__ + "static/media/hr.5899f580.svg";